import {required} from "vuelidate/lib/validators";  
const dpagecategories = {
    data() { 
      return {  
        
        dpagecategoriesData: { 
          Title: "",
          Websiteid: null, 
          Deleted: false
          }, 
          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('dpagecategories.AddEdit.Title'),FieldType:"text"},
             Websiteid:{FieldName:"Title",Field:"input",FieldTitle:this.$t('dpagecategories.AddEdit.Title'),FieldType:"text"},
           
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Title: { required},  
        Websiteid: { required },  
      }
 
  },

  created(){

  }



}
export default dpagecategories